import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkRateAdd } from '../models/models'

export class AddPkRatesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/addRates',
      requesterInfo,
    })
  }

  public async addRates(request: IPkRateAdd): Promise<string> {
    return await this.postAsync<string>(request)
  }
}
